import { find, propEq, when } from 'ramda';
import { toBinary } from 'js/utils/binary.util';
import { addParamsToUrl } from 'js/utils/url.util';

export const getAccount = ({ accounts = [], accountCode }) => find(propEq('code', accountCode), accounts);

export const encData = object => {
    if (!object) {
        return object;
    }

    const data = JSON.stringify(object);

    try {
        return window.btoa(data);
    } catch {
        // btoa takes only binary string as param (1 character = 1 byte):
        // data should be converted to binary if some characters occupy more than 1 byte
        return window.btoa(toBinary(data));
    }
};

export const addClientType = ({ cashierClientType: clienttype }) => when(
    () => clienttype,
    request => ({
        ...request,
        clienttype
    })
);

export const get3dsCallParams = ({ clientIp }) => ({
    threeDSBrowserAcceptHeader: 'text/html',
    threeDSBrowserIP: clientIp,
    threeDSBrowserJavaEnabled: navigator.javaEnabled(),
    threeDSBrowserJavascriptEnabled: true,
    threeDSBrowserLanguage: navigator.language,
    threeDSBrowserColorDepth: screen.colorDepth,
    threeDSBrowserScreenHeight: screen.height,
    threeDSBrowserScreenWidth: screen.width,
    threeDSBrowserTimeZone: (new Date()).getTimezoneOffset(),
    threeDSBrowserUserAgent: navigator.userAgent.substring(0, 2000),
    threeDSChallengeWindowSize: '05' // fullscreen
});

export const addNoPlayerMessageToGs = ({ sendCashierMessagesToGS }) => when(
    () => !sendCashierMessagesToGS,
    request => ({
        ...request,
        xNoPlayermessageToGs: true
    })
);

// Deposit with 3D check: back-urls should always be present
export const addBackUrls = ({ code: type, action, themeName, redirectType, initiator }) => (request) => {
    const { promoCode } = request;

    let extraData;

    if (promoCode) {
        extraData = encData({ promocode: promoCode });
    }

    const urlPaymentPage = new window.URL(`${window.location.origin}/${themeName}/js/app-out/payment.html`);

    const defaultBackUrl = redirectType === 'popup' || redirectType === 'iframe'
        ? urlPaymentPage
        : window.location;

    const params = { type, action, initiator, redirectType, amount: request.amount };

    return {
        ...request,
        successUrl: addParamsToUrl({ ...params, status: 'success', extraData }, defaultBackUrl),
        errorUrl: addParamsToUrl({ ...params, status: 'error' }, defaultBackUrl),
        cancelUrl: addParamsToUrl({ ...params, status: 'cancel' }, defaultBackUrl),
        waitingUrl: addParamsToUrl({ ...params, status: 'waiting' }, defaultBackUrl),
        threeDSErrorURL: addParamsToUrl({ ...params, status: '3DsError' }, urlPaymentPage),
        threeDSSuccessURL: addParamsToUrl({ ...params, status: '3DsSuccess' }, urlPaymentPage),
        threeDSMethodNotificationURL: addParamsToUrl({ ...params, status: '3DsNotification' }, urlPaymentPage)
    };
};

export const addStoreCardConfirmed = ({ storeCardConfirmationRequired }) => when(
    () => storeCardConfirmationRequired,
    request => ({
        ...request,
        storeCardConfirmed: true
    })
);
